import { Injectable } from '@angular/core';
import { EAuthTokenType } from '../enums/types';

@Injectable({ providedIn: 'root' })
export class ConstantsService {
    DATETIME_FORMAT_USER: string = 'DD-MM-YYYY hh:mm A';
    TIME_FORMAT_USER: string = 'hh:mm A';
    DATE_FORMAT: string = 'DD-MM-YYYY';
    DATE_FORMAT_USA: string = 'MM/DD/YYYY';
    TIME_FORMAT: string = 'HH:mm';
    timezone = "Asia/Kolkata";

    authTokenAM = {
        authTokenType: EAuthTokenType.AM,
        authTokenAM: {
            u: 'default',
            p: 'default',
        },
    };

    constructor() {
    }

}
